export class Rol {
    rol_id: number;
    name: string;
    description: string;

  /**
   * Constructor
   *
   * @param rol
   */
  constructor(rol) {
    this.rol_id      = rol.rol_id    || 0;
    this.name        = rol.name        || '';
    this.description = rol.description || '';
  }
}